import React, { createContext, type PropsWithChildren, useContext } from 'react';

import { type TeamContainerType } from '../../ui/team-selector/types';

export type TeamSelectorContextType = {
	cloudId: string;
	orgId: string;
	containerId: string;
	containerType?: TeamContainerType;
};

const TeamSelectorContext = createContext<TeamSelectorContextType>({
	cloudId: '',
	orgId: '',
	containerId: '',
});

export function TeamSelectorProvider({
	children,
	cloudId,
	orgId,
	containerId,
	containerType,
}: PropsWithChildren<TeamSelectorContextType>) {
	return (
		<TeamSelectorContext.Provider
			value={{
				cloudId,
				orgId,
				containerId,
				containerType,
			}}
		>
			{children}
		</TeamSelectorContext.Provider>
	);
}

export const useTeamSelectorContext = () => useContext(TeamSelectorContext);
